import { useCallback } from 'react';

interface UseScheduledOrderPrintResult {
  printOrder: () => void;
}

export function useScheduledOrderPrint(): UseScheduledOrderPrintResult {
  // ! print synchronously: the invoice is already mounted (see ScheduledOrderInvoicePortal)
  const printOrder = useCallback(() => {
    window.print();
  }, []);

  return { printOrder };
}
